var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40.945 45.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7342",
    "data-name": "Group 7342",
    transform: "translate(-2.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22654",
    "data-name": "Path 22654",
    d: "M8.825,10.7A1.586,1.586,0,0,1,7.25,9.124v-6.3a1.575,1.575,0,0,1,3.15,0v6.3A1.586,1.586,0,0,1,8.825,10.7Z",
    transform: "translate(5.499)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22655",
    "data-name": "Path 22655",
    d: "M16.825,10.7A1.586,1.586,0,0,1,15.25,9.124v-6.3a1.575,1.575,0,1,1,3.15,0v6.3A1.586,1.586,0,0,1,16.825,10.7Z",
    transform: "translate(14.297)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22656",
    "data-name": "Path 22656",
    d: "M9.6,16.693a2.09,2.09,0,0,1-.8-.168,2.015,2.015,0,0,1-1.3-1.932,2.09,2.09,0,0,1,.168-.8,2.425,2.425,0,0,1,.441-.693,2.168,2.168,0,0,1,.693-.441,2.144,2.144,0,0,1,2.289.441,2.208,2.208,0,0,1,.609,1.491,3.156,3.156,0,0,1-.042.42,1.335,1.335,0,0,1-.126.378,1.59,1.59,0,0,1-.189.378,3.308,3.308,0,0,1-.252.315,2.208,2.208,0,0,1-1.491.609Z",
    transform: "translate(5.774 12.378)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22657",
    "data-name": "Path 22657",
    d: "M13.1,16.7a2.09,2.09,0,0,1-.8-.168A2.015,2.015,0,0,1,11,14.6a2.09,2.09,0,0,1,.168-.8,2.425,2.425,0,0,1,.441-.693,2.168,2.168,0,0,1,.693-.441,2.1,2.1,0,0,1,2.289.441A2.208,2.208,0,0,1,15.2,14.6a3.156,3.156,0,0,1-.042.42,1.335,1.335,0,0,1-.126.378,1.59,1.59,0,0,1-.189.378,3.308,3.308,0,0,1-.252.315A2.208,2.208,0,0,1,13.1,16.7Z",
    transform: "translate(9.623 12.373)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22658",
    "data-name": "Path 22658",
    d: "M16.6,16.7a2.09,2.09,0,0,1-.8-.168,2.168,2.168,0,0,1-.693-.441l-.252-.315a1.59,1.59,0,0,1-.189-.378,1.335,1.335,0,0,1-.126-.378,3.156,3.156,0,0,1-.042-.42,2.208,2.208,0,0,1,.609-1.491,2.167,2.167,0,0,1,.693-.441,2.1,2.1,0,0,1,2.289.441A2.208,2.208,0,0,1,18.7,14.6a3.156,3.156,0,0,1-.042.42,1.335,1.335,0,0,1-.126.378,1.59,1.59,0,0,1-.189.378,3.308,3.308,0,0,1-.252.315A2.208,2.208,0,0,1,16.6,16.7Z",
    transform: "translate(13.472 12.373)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22659",
    "data-name": "Path 22659",
    d: "M9.6,20.186a2.09,2.09,0,0,1-.8-.168,2.425,2.425,0,0,1-.693-.441A2.208,2.208,0,0,1,7.5,18.086a2.09,2.09,0,0,1,.168-.8,1.959,1.959,0,0,1,.441-.693,2.2,2.2,0,0,1,2.982,0A2.1,2.1,0,0,1,9.6,20.186Z",
    transform: "translate(5.774 16.235)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22660",
    "data-name": "Path 22660",
    d: "M13.1,20.186a2.079,2.079,0,0,1-2.1-2.1,2.09,2.09,0,0,1,.168-.8,1.959,1.959,0,0,1,.441-.693,2.2,2.2,0,0,1,2.982,0,1.959,1.959,0,0,1,.441.693,2.09,2.09,0,0,1,.168.8,2.079,2.079,0,0,1-2.1,2.1Z",
    transform: "translate(9.623 16.235)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22661",
    "data-name": "Path 22661",
    d: "M16.6,20.2a2.208,2.208,0,0,1-1.491-.609,1.96,1.96,0,0,1-.441-.693,1.979,1.979,0,0,1,0-1.6,1.96,1.96,0,0,1,.441-.693A2.1,2.1,0,0,1,17,16.043a1.267,1.267,0,0,1,.4.126,1.59,1.59,0,0,1,.378.189,3.308,3.308,0,0,1,.315.252A2.1,2.1,0,0,1,16.6,20.2Z",
    transform: "translate(13.472 16.22)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22662",
    "data-name": "Path 22662",
    d: "M40.02,11.489H4.325a1.575,1.575,0,1,1,0-3.15h35.7a1.575,1.575,0,1,1,0,3.15Z",
    transform: "translate(0.55 7.797)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22663",
    "data-name": "Path 22663",
    d: "M31.122,44.745h-16.8c-7.664,0-12.074-4.409-12.074-12.074V14.824C2.25,7.159,6.659,2.75,14.324,2.75h16.8C38.786,2.75,43.2,7.159,43.2,14.824V32.671C43.2,40.335,38.786,44.745,31.122,44.745ZM14.324,5.9C8.318,5.9,5.4,8.818,5.4,14.824V32.671c0,6.005,2.919,8.924,8.924,8.924h16.8c6.005,0,8.924-2.919,8.924-8.924V14.824c0-6.005-2.919-8.924-8.924-8.924Z",
    transform: "translate(0 1.65)",
    fill: "#9797bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconCalendar);
export default __webpack_public_path__ + "static/media/TabIconCalendar.1a891221935dc5223bcadb0060a95a99.svg";
export { ForwardRef as ReactComponent };